"use client";

import { cn } from "@frontend/shared/lib/utils";
import * as LabelPrimitive from "@radix-ui/react-label";
import * as React from "react";

export interface KioskLabelProps
  extends React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> {
  required?: boolean;
}

const KioskLabel = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  KioskLabelProps
>(({ className, required, children, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(
      "text-sm md:text-base font-medium leading-none text-gray-900",
      "peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
      className,
    )}
    {...props}
  >
    {children}
    {required && <span className="ml-1 text-red-500">*</span>}
  </LabelPrimitive.Root>
));

KioskLabel.displayName = "KioskLabel";

export { KioskLabel };
